import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import MirunaGallery from '../components/MirunaGallery';
import Footer from '../components/Footer';
import { initScrollAnimations } from '../utils/scrollAnimation';
import '../components/DeveloperPage.css';
import '../styles/global.css';

function MirunaSpineanu() {
  useEffect(() => {
    window.scrollTo(0, 0);
    initScrollAnimations();
  }, []);

  return (
    <main className="developer-page">
      <div className="developer-page-inner">
        <Link to="/" className="back-link scroll-fade-in">← Back to Home</Link>
        <div className="developer-header scroll-fade-in">
          <img
            src="/WebsitePhotos/MirunaSpineanu.jpg"
            alt="Miruna Spineanu"
            className="developer-image"
          />
          <div className="developer-info">
            <h1>Miruna Spineanu</h1>
            <p className="developer-role">Product, Design & Engineering</p>
          </div>
        </div>
        <div className="developer-content scroll-fade-in">
          <p>
            Leads product discovery, visual direction and engineering to keep every
            MythLabs build focused, beautiful and scalable.
          </p>
          <div className="developer-details">
            <h2>About</h2>
            <p>
              Miruna Spineanu specializes in <strong>design</strong>, marketing strategies, and visual communication. 
              A <strong>Computer Science graduate</strong> currently based in Dusseldorf, Germany, she combines 
              technical expertise with creative vision to deliver exceptional digital experiences. 
              Her professional work encompasses illustration, mockup design, and website design, 
              with a strong foundation in understanding cultural nuances and global market dynamics 
              in product development.
            </p>
            <p>
              Miruna has worked on <a href="https://qompyl.com" target="_blank" rel="noopener noreferrer" className="developer-email">Qompyl</a>, 
              bringing her design and development expertise to create engaging user experiences.
            </p>
            <h2>Contact</h2>
            <p>
              <a href="mailto:miruna.spineanu003@gmail.com" className="developer-email">
                miruna.spineanu003@gmail.com
              </a>
            </p>
          </div>
        </div>
        <MirunaGallery />
      </div>
      <Footer />
    </main>
  );
}

export default MirunaSpineanu;

